import { PublicClientApplication } from '@azure/msal-browser';

/** sessionStorage: /login/microsoft üzerinde çift loginRedirect (React Strict Mode) önlemi */
export const MSAL_MAIL_LOGIN_SESSION_KEY = 'helpdesk_msal_mail_login_redirect';

/**
 * CRA reads REACT_APP_* only at build/start. Fallback: public/index.html window.ENV
 * (same pattern as API_URL) so dev machines without .env still work after refresh.
 */
export const getMsalClientId = () => {
  const fromEnv = process.env.REACT_APP_MSAL_CLIENT_ID;
  if (fromEnv && String(fromEnv).trim()) {
    return String(fromEnv).trim();
  }
  if (typeof window !== 'undefined' && window.ENV?.MSAL_CLIENT_ID) {
    return String(window.ENV.MSAL_CLIENT_ID).trim();
  }
  return '';
};

export const getMsalAuthority = () => {
  const fromEnv = process.env.REACT_APP_MSAL_AUTHORITY;
  if (fromEnv && String(fromEnv).trim()) {
    return String(fromEnv).trim();
  }
  if (typeof window !== 'undefined' && window.ENV?.MSAL_AUTHORITY) {
    return String(window.ENV.MSAL_AUTHORITY).trim();
  }
  return 'https://login.microsoftonline.com/common';
};

const getRedirectUri = () => {
  if (process.env.REACT_APP_MSAL_REDIRECT_URI) {
    return process.env.REACT_APP_MSAL_REDIRECT_URI;
  }
  if (typeof window !== 'undefined' && window.ENV?.MSAL_REDIRECT_URI) {
    return window.ENV.MSAL_REDIRECT_URI;
  }
  return `${window.location.origin}/mailcall`;
};

const buildAuthConfig = () => ({
  clientId: getMsalClientId(),
  authority: getMsalAuthority(),
  redirectUri: getRedirectUri(),
});

export const msalScopes = ['User.Read', 'Mail.Read'];

let msalInstance = null;

export const getMsalInstance = () => {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication({
      auth: buildAuthConfig(),
      cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: true,
      },
    });
  }
  return msalInstance;
};

/**
 * OAuth dönüşünde token: önce handleRedirectPromise, olmazsa önbellekte hesap varsa acquireTokenSilent.
 */
export async function resolveMailcallAccessToken(msal) {
  const response = await msal.handleRedirectPromise();
  if (response?.accessToken) {
    return response.accessToken;
  }

  const accounts = msal.getAllAccounts();
  if (accounts.length === 0) {
    return null;
  }

  try {
    const silent = await msal.acquireTokenSilent({
      scopes: msalScopes,
      account: accounts[0],
    });
    return silent?.accessToken || null;
  } catch (e) {
    console.warn('MSAL acquireTokenSilent:', e);
    return null;
  }
}
